module.exports = __webpack_public_path__ + "static/media/btn-langSelect-close.3c459d4d.svg";